import { ReactComponent as Success } from '@basqet-dashboard/common/assets/icons/success.svg';
import { Button } from '@basqet-dashboard/common/components/';
import { formatCryptoCurrency, useNavigateTo } from '@basqet-dashboard/common/utils';
import { useFetchPayoutWallets } from '@hooks/queries';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

const PayoutSuccessView = ({ transactionDetails }) => {
  const { navigateTo } = useNavigateTo();
  const { row_count, amount, currency_slug } = transactionDetails;
  const { refetch: refetchPayoutWallets } = useFetchPayoutWallets();

  const onComplete = () => {
    navigateTo('/payouts');
  };

  useEffect(() => {
    refetchPayoutWallets();
  }, []);
  return (
    <>
      <div className="card">
        <div className="process-info">
          <Success role="img" />
          <h3>Successful!</h3>
          <p className="card__text">
            You have successfully sent {formatCryptoCurrency(amount)} {currency_slug} to {row_count}{' '}
            recipient(s)
          </p>
        </div>
        <Button isFull type="submit" onClick={onComplete}>
          Back to Dashboard
        </Button>
      </div>
    </>
  );
};

PayoutSuccessView.propTypes = {
  transactionDetails: PropTypes.object
};

export { PayoutSuccessView };
